<template>
  <div class="tw-flex tw-items-center !tw-static !tw-mt-0">
    <span
      role="button"
      tabindex="0"
      class="tw-h-6 tw-w-6 tw-inline-flex tw-items-center tw-justify-center tw-rounded-sm tw-p-1 tw-bg-gray-100 tw-text-gray-600 tw-transition tw-duration-200 tw-cursor-pointer hover:tw-bg-gray-200 hover:tw-text-gray-800 active:tw-scale-95 focus:tw-ring-2 focus:tw-ring-gray-300">
      <FontAwesomeIcon :icon="faXmark" class="tw-h-4 tw-w-4" />
    </span>
  </div>
</template>

<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faXmark } from '@fortawesome/free-solid-svg-icons'
</script>
